import styled from 'styled-components';

import { P } from 'common/styles/oc-styled-components';
import { Icon } from 'opencare-crown';

export const Star = styled(Icon)`
  && {
    color: ${(props) => props.color};
    display: inline-block;
    font-size: 10px;
    margin: 0 8px 0 0;
  }
`;

export const WidthP = styled(P)`
  width: 10%;
`;
